import RGL, { WidthProvider } from "react-grid-layout";
import Skeleton from "react-loading-skeleton";

import { DEFAULT_DASHBOARD } from "../../DEFAULT_DASHBOARD.const";
import { DASHBOARD_NUM_COLUMNS } from "../../constants";
import { DashboardViewWidgetSkeleton } from "../DashboardViewWidget/DashboardViewWidgetSkeleton";
import styles from "./DashboardView.module.scss";

const ReactGridLayout = WidthProvider(RGL);

// Generate layout from DEFAULT_DASHBOARD configuration
const layout: RGL.Layout[] =
  DEFAULT_DASHBOARD.properties?.widgets?.map((widget) => ({
    i: widget.id,
    x: widget.metadata?.placement?.x ?? 0,
    y: widget.metadata?.placement?.y ?? 0,
    w: widget.metadata?.placement?.w ?? 1,
    h: widget.metadata?.placement?.h ?? 1,
  })) ?? [];

export const DashboardViewSkeleton = () => {
  return (
    <div className={styles.page}>
      <div className={styles.wrapper}>
        <Skeleton height={32} width={240} />
      </div>
      <div className={styles.rglWrapper}>
        <ReactGridLayout
          layout={layout}
          cols={DASHBOARD_NUM_COLUMNS}
          rowHeight={300}
          margin={[16, 16]}
          isResizable={false}
          isDraggable={false}
        >
          {layout.map((item) => (
            <div key={item.i} className={styles.widgetWrapper}>
              <DashboardViewWidgetSkeleton h={item.h} />
            </div>
          ))}
        </ReactGridLayout>
      </div>
    </div>
  );
};
